import React from 'react'
import cx from 'classnames'
import { useIntl } from 'intl'

import { Icon } from 'components/dataDisplay'
import { ButtonBase, type ButtonBaseProps } from 'components/inputs'

import s from './RoundButton.scss'


export const sizes = [ 32, 64, 72 ] as const

type Size = typeof sizes[number]

export type RoundButtonProps = Pick<ButtonBaseProps, 'to' | 'toTab' | 'href' | 'data-testid' | 'onClick' | 'loading' | 'disabled'> & {
  className?: string
  title: string | Intl.Message
  size: Size
}

const RoundButton: React.CFC<RoundButtonProps> = (props) => {
  const { children, className, title, href, to, toTab, size, loading, disabled, onClick, 'data-testid': dataTestId } = props

  const intl = useIntl()
  const ariaLabel = intl.formatMessage(title)

  const rootClassName = cx(s.button, className, 'rounded-full', s[`size-${size}`], {
    [s.disabled]: disabled,
  })

  return (
    <ButtonBase
      className={rootClassName}
      href={href}
      to={to}
      toTab={toTab}
      disabled={disabled}
      loading={loading}
      aria-label={ariaLabel}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {
        loading ? (
          <Icon name="32/loader" color="gray-30" />
        ) : (
          children
        )
      }
    </ButtonBase>
  )
}


export default RoundButton
